import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { bankTransactionsQueryOptions, OPEN_STATUSES } from '@/features/bank-transactions/api'
import { BankTransactionsReport } from '@/features/bank-transactions/bank-transactions-report'
import {
  bankTxSearchSchema,
  type BankTxSearch,
  toBankTxListParams,
} from '@/features/bank-transactions/search'

export const Route = createFileRoute('/_authed/relatorios/contas-a-pagar')({
  validateSearch: bankTxSearchSchema,
  loaderDeps: ({ search }) => ({
    params: toBankTxListParams(search, 'payable', OPEN_STATUSES),
  }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(bankTransactionsQueryOptions(deps.params)),
  component: Page,
})

function Page() {
  const { t } = useTranslation('nav')
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <BankTransactionsReport
      direction="payable"
      statuses={OPEN_STATUSES}
      showSettledColumn={false}
      title={t('reports.payable')}
      search={search}
      onSearchChange={(patch) => {
        // `to` EXPLÍCITO: sem ele o destino fica ambíguo, o `prev` do updater cai
        // em `any` (TS7006) e a navegação pode virar no-op silencioso.
        void navigate({
          to: '/relatorios/contas-a-pagar',
          search: (prev: BankTxSearch) => ({ ...prev, ...patch }),
          replace: true,
        })
      }}
    />
  )
}
